// Preloads all assets, then transitions to the main menu.

import { CHAMPIONS } from "../data/champions";
import { ENEMIES } from "../data/enemies";
import { championIconUrl, zoneHexUrl } from "../config/constants";
import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import { MainMenuScene } from "./MainMenuScene";
import { DevScene } from "./DevScene";

export class BootScene implements Scene {
  private root: HTMLDivElement;
  private barFill: HTMLDivElement;
  private label: HTMLDivElement;

  constructor(private game: Game) {
    this.root = document.createElement("div");
    this.root.className = "boot-screen";
    this.root.innerHTML = `
      <div class="menu-title" style="font-size:32px">LOADING</div>
      <div class="boot-bar"><div class="boot-bar-fill" style="width:0%"></div></div>
      <div class="menu-subtitle" style="margin-top:4px">...</div>
    `;
    this.barFill = this.root.querySelector(".boot-bar-fill") as HTMLDivElement;
    this.label = this.root.querySelector(".menu-subtitle") as HTMLDivElement;
  }

  async enter(): Promise<void> {
    this.game.sceneRoot.appendChild(this.root);

    const urls: string[] = [
      `${import.meta.env.BASE_URL}images/map/display%20map.png`,
      `${import.meta.env.BASE_URL}images/tibbers.png`, // Annie's summon
      `${import.meta.env.BASE_URL}images/ghoul.png`,  // Yorick's ghouls
      `${import.meta.env.BASE_URL}images/map/background.png`,
      `${import.meta.env.BASE_URL}images/map/backgrounds/freljord.jpg`,
      `${import.meta.env.BASE_URL}images/map/backgrounds/demacia.jpg`,
      `${import.meta.env.BASE_URL}images/map/backgrounds/noxus.jpg`,
      `${import.meta.env.BASE_URL}images/map/backgrounds/piltover.jpg`,
      `${import.meta.env.BASE_URL}images/map/backgrounds/shurima.jpg`,
      `${import.meta.env.BASE_URL}images/map/backgrounds/targon.jpg`,
      `${import.meta.env.BASE_URL}images/map/backgrounds/ixtal.jpg`,
      `${import.meta.env.BASE_URL}images/map/minion.png`,
      `${import.meta.env.BASE_URL}images/map/recruit.png`,
      `${import.meta.env.BASE_URL}images/map/gromp.png`,
      `${import.meta.env.BASE_URL}images/map/scuttle.png`,
      `${import.meta.env.BASE_URL}images/map/healing.png`,
      `${import.meta.env.BASE_URL}images/map/wolf.png`,
      `${import.meta.env.BASE_URL}images/map/raptor.png`,
      `${import.meta.env.BASE_URL}images/map/krug.png`,
      `${import.meta.env.BASE_URL}images/map/boss.png`,
      `${import.meta.env.BASE_URL}images/map/random.png`,
    ];
    urls.push(zoneHexUrl(true), zoneHexUrl(false));
    urls.push(zoneHexUrl(true, true), zoneHexUrl(false, true));
    for (const champ of Object.values(CHAMPIONS)) {
      urls.push(championIconUrl(champ.iconId));
    }
    for (const enemy of Object.values(ENEMIES)) {
      urls.push(enemy.iconPath);
    }

    await this.game.assets.preload(urls, ({ loaded, total }) => {
      const pct = total === 0 ? 100 : Math.floor((loaded / total) * 100);
      this.barFill.style.width = `${pct}%`;
      this.label.textContent = `${loaded} / ${total} assets`;
    });

    // Small pause so "100%" is visible. Defer the next transition to a fresh
    // macrotask so SceneManager's in-flight transition() has fully unwound
    // (its `finally` has cleared the `transitioning` flag) before we call it.
    await new Promise((r) => setTimeout(r, 150));
    setTimeout(() => {
      if (this.game.debug) {
        this.game.sceneManager.transition(new DevScene(this.game));
      } else {
        this.game.sceneManager.transition(new MainMenuScene(this.game));
      }
    }, 0);
  }

  exit(): void {
    this.root.remove();
  }

  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
